import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { GbxsoftInputConfig } from '@form/src/lib/gbxsoft-input/interfaces/gbxsoft-input.interface';
import { GbxsoftInputTypes } from '@form/src/lib/gbxsoft-input/gbxsoft-input.types';
import { UntypedFormGroup } from '@angular/forms';
import {
  CountryPickerComponent,
  CountryPickerEvent,
  CountryPickerEventType,
} from './components/country-picker/country-picker.component';
import { BaseComponent } from '../base.component';
import { GbxsoftInputComponent } from '@form/src/public-api';
import { Config } from '@shared/configs/config';

@Component({
  selector: 'phone-input',
  templateUrl: './phone-input.component.html',
  styles: [],
})
export class PhoneInputComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('input') input: GbxsoftInputComponent;

  private _form: UntypedFormGroup;

  @Input()
  set form(form: UntypedFormGroup) {
    this._form = form;
    if (this.countryPickerComponent) {
      this.countryPickerComponent.form = form;
      this.countryPickerComponent.checkFormPhoneFlagValue();
      this.countryPickerComponent.ref.detectChanges();
    }
  }

  get form() {
    return this._form;
  }

  @Input() phoneFlagName: string;
  @Input() phoneName: string;
  @Input() config: GbxsoftInputConfig;
  @Input() disabled: boolean;
  @ViewChild('countryPickerComponent') countryPickerComponent: CountryPickerComponent;

  changesEmitter: EventEmitter<CountryPickerEvent> = new EventEmitter();

  constructor(public changes: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.config ? (this.config.type = GbxsoftInputTypes.NUMBER) : null;
    this.initListener();
  }

  initListener() {
    this.sub = this.changesEmitter.subscribe((e: CountryPickerEvent) => {
      if (e.eventType === CountryPickerEventType.CHOSE) {
        this.input ? this.input.inputElement.focus() : null;
      }
    });
  }

  ngAfterViewInit() {
    const inp: HTMLInputElement = this.input.gbxsoftInput.nativeElement;
    inp.onpaste = this.cleanPhoneNumber.bind(this);
  }

  recalculateFlag() {
    this.countryPickerComponent.checkFormPhoneFlagValue();
    this.countryPickerComponent.ref.detectChanges();
  }

  cleanPhoneNumber(e) {
    e.preventDefault();
    let pastedText = '';

    if (e.clipboardData && e.clipboardData.getData) {
      // Standards Compliant FIRST!
      pastedText = e.clipboardData.getData('text/plain');
    } else if (window['clipboardData'].getData) {
      // IE
      pastedText = window['clipboardData'].getData('Text');
    }

    this.form.get(this.phoneName).setValue(pastedText.replace(/\D/g, ''));
  }

  errorMessages(name: string) {
    return Config.validationMessages;
  }
}
